import * as orderAPI from '../api/orders'
import * as types    from "../mutation-types"

// initial state
const orders = {
  namespace: 'orders',
  state: {
    all: [],
    past_orders: [],
    last_sync: null,
  },
  getters: {
    ordersLastSync: (state) => state.last_sync,
    allOrders: (state) => state.all.sort((a, b) => b.id - a.id),
    orders: (state, getters) => {
      if (getters.company.initials === 'CF') {
        return state.all
                    .filter(order => order.company !== 'BELLS')
                    .sort((a, b) => b.id - a.id)
      }
      else {
        return state.all
                    .filter(order => getters.company.initials === null
                                     || order.company === getters.company.initials)
                    .sort((a, b) => b.id - a.id)
      }
    },
    pastOrders: (state, getters) => {
      if (getters.company.initials === 'CF') {
        return state.past_orders
                    .filter(order => order.company !== 'BELLS')
                    .sort((a, b) => b.id - a.id)
      }
      else {
        return state.past_orders
                    .filter(order => getters.company.initials === null
                                     || order.company === getters.company.initials)
                    .sort((a, b) => b.id - a.id)
      }
    },
    allNonVoidedOrders: (state, getters) => getters.orders.filter(order => order.voided === false),
    allPastAndCurrentOrders: (state, getters) => getters.orders.filter(order => order.voided === false)
                                                        .concat(getters.pastOrders
                                                                       .filter(order => order.voided === false)),
    paypalOrders: (state, getters) => getters.allNonVoidedOrders.filter(order => order.payment_method === 'Paypal'),
    cardOrders: (state, getters) => getters.allNonVoidedOrders.filter(order => order.payment_method !== 'Paypal'),
    newOrders: (state, getters) => getters.orders.filter(order => {
      return (order.printed === false && order.archived === false && order.voided === false)
    }),
    newOrdersByCompany: (state, getters) => getters.allOrders.filter(order => {
      return (order.printed === false && order.archived === false && order.voided === false)
    }),
    printedOrders: (state, getters) => getters.orders.filter(order => {
      return (order.printed === true && order.archived === false && order.voided === false)
    }),
    archivedOrders: (state, getters) => getters.orders.filter(order => {
      return (order.archived === true && order.voided === false)
    }),
    voidedOrders: (state, getters) => getters.orders.filter(order => order.voided === true)
  },
  mutations: {
    [types.MARK_PRINTED_ORDERS]: (state, orders) => {
      for (let orderIndex in orders) {
        let orderID          = orders[orderIndex]
        let updateOrder      = state.all.find(order => order.id === orderID)
        let updateOrderIndex = state.all.indexOf(updateOrder)
        let newOrder         = JSON.parse(JSON.stringify(state.all[updateOrderIndex]))
        if (newOrder.printed !== true || newOrder.printed_at === null) {
          newOrder.printed    = true
          newOrder.printed_at = Date.now()
        }

        state.all.splice(updateOrderIndex, 1, newOrder)
      }
    },
    [types.MARK_UNPRINTED_ORDERS]: (state, orders) => {
      for (let orderIndex in orders) {
        let orderID          = orders[orderIndex]
        let updateOrder      = state.all.find(order => order.id === orderID)
        let updateOrderIndex = state.all.indexOf(updateOrder)
        let newOrder         = JSON.parse(JSON.stringify(state.all[updateOrderIndex]))
        newOrder.printed     = false

        state.all.splice(updateOrderIndex, 1, newOrder)
      }
    },
    [types.ARCHIVE_ORDER]: (state, orders) => {
      for (let orderIndex in orders) {
        let orderID          = orders[orderIndex]
        let updateOrder      = state.all.find(order => order.id === orderID)
        let updateOrderIndex = state.all.indexOf(updateOrder)
        let newOrder         = JSON.parse(JSON.stringify(state.all[updateOrderIndex]))
        newOrder.archived    = true

        state.all.splice(updateOrderIndex, 1, newOrder)
      }
    },
    [types.UNARCHIVE_ORDER]: (state, orders) => {
      for (let orderIndex in orders) {
        let orderID          = orders[orderIndex]
        let updateOrder      = state.all.find(order => order.id === orderID)
        let updateOrderIndex = state.all.indexOf(updateOrder)
        let newOrder         = JSON.parse(JSON.stringify(state.all[updateOrderIndex]))
        newOrder.archived    = false

        state.all.splice(updateOrderIndex, 1, newOrder)
      }
    },
    [types.VOID_ORDER]: (state, orders) => {
      for (let orderIndex in orders) {
        let orderID          = orders[orderIndex]
        let updateOrder      = state.all.find(order => order.id === orderID)
        let updateOrderIndex = state.all.indexOf(updateOrder)
        let newOrder         = JSON.parse(JSON.stringify(state.all[updateOrderIndex]))
        newOrder.voided      = true

        state.all.splice(updateOrderIndex, 1, newOrder)
      }
    },
    [types.UNVOID_ORDER]: (state, orders) => {
      for (let orderIndex in orders) {
        let orderID          = orders[orderIndex]
        let updateOrder      = state.all.find(order => order.id === orderID)
        let updateOrderIndex = state.all.indexOf(updateOrder)
        let newOrder         = JSON.parse(JSON.stringify(state.all[updateOrderIndex]))
        newOrder.voided      = false

        state.all.splice(updateOrderIndex, 1, newOrder)
      }
    },
    [types.LOAD_NEW_ORDERS]: (state, orders) => {
      state.all       = state.all.concat(orders)
      state.last_sync = Date.now()
    },
    [types.LOAD_ALL_ORDERS]: (state, orders) => {
      state.all       = orders
      state.last_sync = Date.now()
    },
    [types.REFRESH_OR_ADD_ORDERS]: (state, orders) => {
      for (let x = 0; x < orders.length; x++) {
        let refreshedOrder = orders[x];
        let existingOrder  = state.all.find(order => order.id === refreshedOrder.id);
        if (typeof existingOrder !== 'undefined') {
          state.all.splice(state.all.indexOf(existingOrder), 1, refreshedOrder)
        }
        else {
          state.all.push(refreshedOrder)
        }
      }
    },
    [types.REFRESH_ORDERS]: (state, data) => {
      for (let x = 0; x < data.orders.length; x++) {
        let refreshedOrder = data.orders[x];
        let existingOrder  = state.all.find(order => order.id === refreshedOrder.id);
        if (existingOrder !== -1 && typeof existingOrder !== 'undefined') {
          state.all.splice(state.all.indexOf(existingOrder), 1, refreshedOrder)
        }
        else {
          state.all.push(refreshedOrder)
        }
      }
      state.last_sync = Date.now()
    },
    [types.LOAD_ORDER]: (state, loadedOrder) => {
      state.all.splice(state.all.indexOf(state.all.find(order => order.id === loadedOrder.id)), 1, loadedOrder)
    }
  },

  actions: {
    [types.REFRESH_ORDERS]: ({ commit, dispatch, state }, showload = true) => {
      return new Promise((resolve, reject) => {
        let orders = state.all.filter(order => order.printed === true).sort((a, b) => a.id - b.id)
        if (orders.length === 0) {
          orders = state.all.filter(order => order.printed === false
                                             && order.archived === false
                                             && order.voided === false)
                        .sort((a, b) => a.id - b.id)
        }
        if (orders.length === 0) {
          orders = state.all.sort((a, b) => a.id - b.id)
        }
        if (orders.length === 0) {
          return false;
        }
        orderAPI.refreshOrders(commit, orders[orders.length - 1].id, showload)
                .then(data => {
                  commit(types.REFRESH_ORDERS, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.LOAD_NEW_ORDERS]: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        let orders = state.all.sort((a, b) => {
          return b.id - a.id
        })
        orderAPI.loadNewOrders(commit, orders[0].id)
                .then(data => {
                  commit(types.LOAD_NEW_ORDERS, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.LOAD_ORDER]: ({ commit, dispatch, state }, order_id) => {
      return new Promise((resolve, reject) => {
        orderAPI.loadOrder(commit, order_id)
                .then(data => {
                  commit(types.LOAD_ORDER, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.LOAD_ALL_ORDERS]: ({ commit, dispatch, state }, options) => {
      return new Promise((resolve, reject) => {
        orderAPI.loadOrders(commit, options)
                .then(data => {
                  commit(types.LOAD_ALL_ORDERS, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.MARK_PRINTED_ORDERS]: ({ commit, dispatch, state }, orders) => {
      return new Promise((resolve, reject) => {
        orderAPI.markOrderPrinted(commit, { orders })
                .then(data => {
                  commit(types.MARK_PRINTED_ORDERS, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.MARK_UNPRINTED_ORDERS]: ({ commit, dispatch, state }, orders) => {
      return new Promise((resolve, reject) => {
        orderAPI.markOrderNotPrinted(commit, { orders })
                .then(data => {
                  commit(types.MARK_UNPRINTED_ORDERS, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.ARCHIVE_ORDER]: ({ commit, dispatch, state }, orders) => {
      return new Promise((resolve, reject) => {
        orderAPI.archiveOrder(commit, { orders })
                .then(data => {
                  commit(types.ARCHIVE_ORDER, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.UNARCHIVE_ORDER]: ({ commit, dispatch, state }, orders) => {
      return new Promise((resolve, reject) => {
        orderAPI.unarchiveOrder(commit, { orders })
                .then(data => {
                  commit(types.UNARCHIVE_ORDER, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.VOID_ORDER]: ({ commit, dispatch, state }, orders) => {
      return new Promise((resolve, reject) => {
        orderAPI.voidOrder(commit, { orders })
                .then(data => {
                  commit(types.VOID_ORDER, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.UNVOID_ORDER]: ({ commit, dispatch, state }, orders) => {
      return new Promise((resolve, reject) => {
        orderAPI.unvoidOrder(commit, { orders })
                .then(data => {
                  commit(types.UNVOID_ORDER, data)
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
    [types.UPDATE_ACCOUNT_NUMBER]: ({ commit, dispatch, state }, { order_id, account_number }) => {
      return new Promise((resolve, reject) => {
        orderAPI.updateAccountNumber(commit, { order_id, account_number })
                .then(data => {
                  commit(types.LOAD_ORDER, data.order)
                  if (data.user) {
                    commit(types.UPDATE_USER, data.user)
                  }
                  resolve(data)
                })
                .catch(errors => {
                  reject(errors)
                })
      })
    },
  },
};

export default orders;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/orders/index.js
// module id = 617
// module chunks = 0